<template>
  <div class="animated fadeIn certificado-servicios">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card header="Información del Certificado de Servicio">
            <app-cliente
              label="Cliente"
              :nombre="clienteFacturacionNombre"
              :labelCols="labelCols"
              :valido="clienteValido"
              :lista="clientesList"
              :msjInvalido="clienteInvalidoMsj"
              @validate="validate"
              @updated="clienteActualizado">
            </app-cliente>  

            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="3"
                max-rows="6"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-card>

          <b-card header="Información del Presupuesto">
            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="cliente" 
                readonly>
              </b-form-input>
            </b-form-group>
            
            <b-form-group
              label="Accion"
              label-for="accion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="accion"
                :value="accion" 
                readonly>
              </b-form-input>
            </b-form-group>
            
            <b-form-group
              label="Contacto"
              label-for="clienteContacto"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="clienteContacto"
                :value="clienteContacto" 
                readonly>
              </b-form-input>
            </b-form-group>
          </b-card>

          <b-card header="Ordenes de Trabajo">
            <b-table 
                small 
                responsive="sm"
                class="registro-ordenes" 
                :items="renglones" 
                :fields="fields">
              <template v-slot:cell(importeNeto)="data">
                {{ data.item.importeNeto | moneda(data.item.moneda) }}
              </template>
              <template v-slot:cell(pjeMaximoCertificar)="data">
                {{ data.item.pjeMaximoCertificar | numero(2, true) }}
              </template>
              <template v-slot:cell(pjeCertificado)="data">
                  <input type="number"
                      step="0.01"
                      v-if="data.item.pjeMaximoCertificar != 0"
                      v-model="data.item.pjeCertificado"
                      @input="actualizarPjeCertificado(data.item)"/>
                  <template  v-if="data.item.pjeMaximoCertificar == 0">
                    {{ data.item.pjeCertificado | numero(2, true) }}
                  </template>
              </template>
              <template v-slot:cell(importe)="data">
                  <template  v-if="data.item.pjeMaximoCertificar != 0">
                    <app-formatted-currency 
                      :id="data.item.ordenTrabajoId.toString()"
                      :importe="data.item.importe"
                      :moneda="data.item.moneda"
                      @actualizarImporte="actualizarImporteCertificado">
                    </app-formatted-currency>
                  </template>
                  <!-- <input type="number" 
                      step="0.01"
                      v-if="data.item.pjeMaximoCertificar != 0"
                      v-model="data.item.importe"
                      @input="actualizarImporteCertificado(data.item)"/> -->
                  <template  v-if="data.item.pjeMaximoCertificar == 0">
                    {{ data.item.importe | moneda }}
                  </template>
              </template>
            </b-table>
          </b-card>

          <b-card header="Totales">
            <b-form-group
              label="Importe"
              label-for="importe"
              :label-cols="1"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="setImporteTotal">
                  <b-input-group-text>
                    <i class="fa fa-edit"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="importe"
                  :value="importe | moneda(moneda)" 
                  readonly>
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="seleccionFechaModal"
        title="Fecha de Cierre del Presupuesto"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-seleccion-fecha
        :fechaInicial="fechaCierreEstimado"
        descripcion="Fecha de cierre estimado del presupuesto"
        @fechaSeleccionada="fechaSeleccionada"
        @seleccionFechaCancelada="seleccionFechaCancelada">
      </app-seleccion-fecha>  
    </b-modal>

    <b-modal ref="importeTotalModal"
        title="Importe Total a Certificar"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-importe-total
        @close="closeImporteTotal">
      </app-importe-total>  
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Cliente from '../shared/abmSelect.vue';
import ImporteTotal from './ImporteTotal.vue';
import SeleccionFecha from '../shared/seleccionFecha.vue';
import FormattedCurrency from '../shared/formattedCurrency.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, numeric, maxLength } from 'vuelidate/lib/validators';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'certificadoServicio/getField',
  mutationType: 'certificadoServicio/updateField',
});

export default {
  name: 'CertificadoServicioABM',
  components: {
    appABMButton: ABMButtons,
    appCliente: Cliente,
    appImporteTotal: ImporteTotal,
    appSeleccionFecha: SeleccionFecha,
    appFormattedCurrency: FormattedCurrency,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      clienteValido: null,
      clienteInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      clientes: [],
      clientesList: [],

      fields: [
        {
          key: 'rubroTrabajo',
          label: 'Rubro'
        },
        {key: 'titulo'},
        // {key: 'descripcion'},
        {
          key: 'importeNeto',
          label: 'Cotización',
          class: 'text-right'
        },
        {
          key: 'pjeMaximoCertificar',
          label: 'Saldo a Cert.',
          class: 'text-right'
        },
        {
          key: 'pjeCertificado',
          class: 'text-right'
        },
        {
          key: 'importe',
          class: 'text-right'
        },
      ],

      labelCols: 2,

      fechaCierreEstimado: moment(new Date()).add(30, 'days').format('YYYY-MM-DD'),
    }
  },
  computed: {
    ...mapFields([
      'id',
      'clienteFacturacion',
      'clienteFacturacionNombre',
      'cliente',
      'accion',
      'clienteContacto',
      //'descripcion',
      'moneda',
      'importe',
      'observaciones',
      'renglones',
    ]),
  },  
  created() {
    this.getDatosAdicionales();
    
    let presupuestoId = 0;
    let certificadoServicioId = 0;
    
    if (this.$route.params){
      if (this.$route.params.id){
        certificadoServicioId = this.$route.params.id;
      }
      if (this.$route.params.presupuestoId){
        presupuestoId = this.$route.params.presupuestoId;
      }
    }

    let params = {
      presupuestoId,
      certificadoServicioId
    }

    this.showSpinner();
    this.$store.dispatch('certificadoServicio/inicializar', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },
  methods: {
    getDatosAdicionales() {
      let vm = this;
      vm.$store.dispatch('clientes/getList')
        .then(() => {
          vm.clientes = this.$store.getters['clientes/list'];
          vm.clientesList = this.$store.getters['clientes/selectList'];
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de clientes.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      // if (campo == "descripcion" || validarTodos) {
      //   if (this.$v.descripcion.$error) {
      //     this.descripcionValida = false;
      //     if (!this.$v.descripcion.maxLength) {
      //       this.descripcionInvalidaMsj = 'La descripción de la PO del certificado sólo puede contener hasta 150 caracteres.';
      //     }
      //   } else {
      //     this.descripcionValida = null;
      //     this.descripcionInvalidaMsj = '';
      //   }
      // }

      if (campo == "observaciones" || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo puede contener hasta 5000 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let clienteFacturacion;
      if (this.clienteFacturacionNombre) {
        clienteFacturacion = this.getSelected(this.clientes, this.clienteFacturacionNombre);
      }

      this.$store.dispatch('certificadoServicio/setClienteFacturacion', clienteFacturacion);

      let errorClienteFacturacion = true;
      if (this.clienteFacturacion) {
        if (this.clienteFacturacion.id) {
          if (this.clienteFacturacion.id != 0) {
            errorClienteFacturacion = false;
          }
        }
      }
      if (errorClienteFacturacion) {
        this.clienteValido = false;
        this.clienteInvalidoMsj = 'Debe seleccionar el cliente correspondiente a la facturación.';
        save = false;
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          let tieneSaldoCertificar = this.$store.getters['certificadoServicio/tieneSaldoCertificar'];
          if ((/true/i).test(tieneSaldoCertificar)) {
            this.saveCertificado();
          } else {
            /* Se certificó el 100% del presupuesto (debe ingresar la fecha de cierre estimada) */
            this.$refs.seleccionFechaModal.show();
          }
        }
      }
    },
    saveCertificado(fechaCierre) {
      this.showSpinner();
      this.$store.dispatch('certificadoServicio/save', fechaCierre)
        .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    fechaSeleccionada(fecha) {
      this.$refs.seleccionFechaModal.hide();
      this.saveCertificado(fecha);
    },
    seleccionFechaCancelada() {
      this.$refs.seleccionFechaModal.hide();
    },
    goList() {
      this.modalRegistroExitoso = false
      this.$router.push({ name: "CertificadosServicio" });
    },
    actualizarPjeCertificado(item) {
      let params = {
        ordenTrabajoId: item.ordenTrabajoId,
        pjeCertificado: item.pjeCertificado
      }
      this.$store.dispatch('certificadoServicio/updatePjeCertificado', params)
        .catch(error => this.showErrorMsj(error));
    },
    actualizarImporteCertificado(params) {
      params.ordenTrabajoId = parseInt(params.id);
      
      this.$store.dispatch('certificadoServicio/updateImporteCertificado', params)
        .catch(error => this.showErrorMsj(error));
    },
    // actualizarImporteCertificado(item) {
    //   let params = {
    //     ordenTrabajoId: item.ordenTrabajoId,
    //     importe: item.importe
    //   }
    //   this.$store.dispatch('certificadoServicio/updateImporteCertificado', params)
    //     .catch(error => this.showErrorMsj(error));
    // },
    clienteActualizado(clienteNombre) {
      this.clienteFacturacionNombre = clienteNombre;

      this.clienteValido = null;
      this.clienteInvalidoMsj = '';
    },

    setImporteTotal() {
      this.$refs.importeTotalModal.show();
    },
    closeImporteTotal(importeTotal) {
      this.$refs.importeTotalModal.hide();
      if (importeTotal != 0) {
        this.$store.dispatch('certificadoServicio/setImporteTotal', parseFloat(importeTotal))
          .catch(error => this.showErrorMsj(error));
      }
    }
  },
  validations: {
    // descripcion: {
    //   maxLength: maxLength(150)
    // },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  }    
}
</script>

<style>
  .certificado-servicios .registro-ordenes table td {
    vertical-align: middle;
    border: none;
  }
  .certificado-servicios .registro-ordenes table td[aria-colindex="1"] {
    /* width: 30%; */
    width: 28%;
  }
  .certificado-servicios .registro-ordenes table td[aria-colindex="2"] {
    /* width: 30%; */
    width: 28%;
  }
  .certificado-servicios .registro-ordenes table td[aria-colindex="3"] {
    /* width: 10%; */
    width: 12%;
  }
  .certificado-servicios .registro-ordenes table td[aria-colindex="4"],
  .certificado-servicios .registro-ordenes table td[aria-colindex="5"] {
    width: 10%;
  }
  .certificado-servicios .registro-ordenes table td[aria-colindex="6"] {
    /* width: 10%; */
    width: 12%;
  }
  .certificado-servicios .registro-ordenes table td input {
    width: 70%;
    left: 5%;
    margin: 0; 
    text-align: right;
    /* -moz-appearance:textfield; */
    border: none;
    border-bottom: 1px solid rgba(32, 168, 216, 0.8);
  }
  .certificado-servicios .registro-ordenes table td input[type=number]::-webkit-inner-spin-button, 
  .certificado-servicios .registro-ordenes table td input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
  }
</style>
